import { STORAGE_KEYS } from '@/common/common-enum';

/**
 * localStorage에서 사용자 정보를 파싱하여 반환하는 공통 유틸리티
 * @returns {Object|null} 파싱된 사용자 객체. 사용자를 찾지 못하거나 파싱 오류 시 null을 반환합니다.
 */
export function parseUserFromStorage() {
  try {
    const userStr = localStorage.getItem(STORAGE_KEYS.USER);
    if (!userStr) {
      return null;
    }

    const parsedUser = JSON.parse(userStr);
    
    // 타입 안전성 검증: 객체가 아니거나 배열인 경우 null 반환
    if (!parsedUser || typeof parsedUser !== 'object' || Array.isArray(parsedUser)) {
      return null;
    }

    // 사용자 객체 생성
    const user = {
      id: parsedUser.id || null,
      accessToken: parsedUser.accessToken || null,
      userRoleType: parsedUser.userRoleType || null,
      roleType: parsedUser.roleType || null,
    };

    // 유효성 검증: id 또는 accessToken 중 하나라도 있어야 유효한 사용자
    if (!user.id && !user.accessToken) {
      return null;
    }

    return user;
  } catch (error) {
    console.warn("Failed to parse user data from localStorage:", error);
    return null;
  }
}
